import React from 'react'
import Tabs from './Components/Tabs/Tabs'

const Inventory = () => {
  return (
    <>
      <div className='inventory-body'>
        <Tabs/>
      </div>
    </>
  )
}

export default Inventory